const firebase = require("firebase/app");
require("firebase/database");

const io = require('socket.io-client');
const Chart = require('chart.js');
const $ = require("jquery");
window.$ = $;
require("bootstrap-material-design");
require('typeface-roboto');
require("material-design-icons");
const config = require('../config.js');
window.config = config;
const Graphic = require('./graphs.js');
const GMap = require("./map.js");
const Auth = require("./auth.js")
const GraphSelector = require("./graph-selector.js");
const play = require('./speech.js');

firebase.initializeApp(config.fireBaseConfig);

var graphs = {}
let currentValues = {}
let tx_rate = 100;
let sd_rate = 100;

let gmap;

let previousH;
let previousH_time;
let vvel;
let hbmp = 0;

function parseNewValue(key, val) {
  let value = val.value;
  currentValues[key] = value;
  graphs[key].addInstantValue(value);
  $("#title-" + key).html(value);
}

let socket;
$(function () {

  let calcs = function () {
    let availableHeight = window.innerHeight;
    availableHeight -= $("#main-cards").position().top + 25;
    availableHeight -= $(".footer").height();
    $("#main-cards").height(availableHeight);
  }
  calcs();
  calcs();
  calcs();
  setInterval(calcs, 1000);

  let gmap = new GMap(["embedded-map"], function () {
    firebase.database().ref("/sats/a_sat/antennas").on("value", function (snap) {
      let value = snap.val();
      let markers = {};
      for (let antenna of Object.keys(value)){
        markers[antenna] = {};
        markers[antenna].position = new google.maps.LatLng(value[antenna].latitude, value[antenna].longitude);
        markers[antenna].timestamp = value[antenna].timestamp;
        markers[antenna].clickable = false;
      }

      gmap.updateMarkers(markers);
      //console.log(markers);

      socket.on("lat", function (data) {
        gmap.updateCansatLat(data);
      });

      socket.on("lng", function (data) {
        gmap.updateCansatLng(data);
      })
    });

    gmap.setupRecoverMap();
    gmap.updateCansat();
  });





  var database = firebase.database();
  socket = io(config.socketServer[localStorage.sat]);

  $("#continue-guestmode").click(function () {
    $("#welcome-login").hide();
  });

  if (typeof localStorage.sat == "undefined") {
    //location.href = "./selector.html"
    localStorage.setItem("sat", "a_sat");
  }

  let listen_to_graphs = ["tbmp", "tmpu","pbmp", "hbmp", "hgps", "vbmp", "a", "tntc"];
//  let config.baseUrl = 'sats/' + localStorage.sat + "/";
  listen_to_graphs.forEach(function (parameter) {
    let includeZero;
    if($("#graph-" + parameter).attr("includeZero") == "true"){
      includeZero = true;
    } else {
      includeZero = false
    }
    graphs[parameter] = new Graphic(parameter, includeZero, "graph-" + parameter);
    socket.on(parameter, function (value) {
      graphs[parameter].addInstantValue(value);
    });
  });

  socket.emit("resend"); // request resend of last values


  let listen_to_params = ["hbmp", "atotal", "tntc", "pbmp", "gpslat", "gpslng", "volt", "hrdr", "pl1", "pl2", "fr1", "fr2", "vbat", "tntc", "vbmp", "a"];
  listen_to_params.forEach(function (parameter) {
    socket.on(parameter, function (value) {
      if(parameter == "hbmp"){
        $("#label-hbmp").html(value);
        hbmp = value;
      } else if (parameter == "atotal"){
        $("#label-atotal").html(value);
      } else if (parameter == "tntc"){
        $("#label-tntc").html(value);
      } else if(parameter == "pbmp"){
        $("#label-pbmp").html(value);
      } else if(parameter == "volt"){
        $("#label-voltage").html(value);
      } else if(parameter == "gpslat"){
        gmap.updateCansatLat(value / 100000);
      } else if(parameter == "gpslng"){
        gmap.updateCansatLng(value / 100000);
      } else if(parameter == "hrdr"){
        $("#label-hrdr").html(value);
      } else if(parameter === "pl1" || parameter === "pl2") {
        $("#label-" + parameter).html(Math.round(value * 10000) / 100);
      } else if(parameter ==="vbat"){
        $("#label-vbat").html(value);
        const percent = Math.round(((value - 3.3)/0.9) * 100);
        $("#label-vbat-percent").html(percent);
      } else {
        $("#label-" + parameter).html(Math.round(value*1000)/1000);
      }
    });
  });



  //
  // PARACHUTE.
  //


  firebase.database().ref(config.baseUrl + "pc-openh").on('value', function(snapshot) {
    //$("#parachute-inputh").val(snapshot.val().value);
    $("#label-ph").html(snapshot.val().value);
  });

  firebase.database().ref(config.baseUrl + "pc-progh").on('value', function(snapshot) {
    $("#label-pprog").html(snapshot.val().value);
  });

  firebase.database().ref(config.baseUrl + "config/parachute_height").on("value", function (snapshot) {
    $("#parachute-inputh").val(snapshot.val().value);
  });

  firebase.database().ref(config.baseUrl + "config/parachute_program").on("value", function (snapshot) {
    $("#parachute-inputhprog").val(snapshot.val().value);
  });

  firebase.database().ref(config.baseUrl + "parachute_open").on('value', function(snapshot) {
    if(snapshot.val().value){
      $("#parachute-status").html("ABIERTO");
      $("#parachute-status").attr("class", "label-abierto");
      play("parachute_opened");
    } else {
      $("#parachute-status").html("CERRADO");
      $("#parachute-status").attr("class", "label-cerrado");
      play("parachute_closed");
    }
  });


  firebase.database().ref(config.baseUrl + "parachute_programmed").on('value', function(snapshot) {
    if(snapshot.val().value){
      $("#parachute-program").html("PROGRAMADO");
      $("#parachute-program").attr("class", "label-programado");
      play("parachute_programmed");

    } else {
      $("#parachute-program").html("DESPROGRAMADO");
      $("#parachute-program").attr("class", "label-desprogramado");
      play("parachute_unprogrammed");

    }
  });

  firebase.database().ref(config.baseUrl + "connection").on("value", function (snapshot) {
    if(snapshot.val().value){
      play("connection_stablished");
    } else {
      play("connection_lost");
    }
  })

  $("#parachute-update").click(function () {
    let openH = $("#parachute-inputh").val();
    let progH = $("#parachute-inputhprog").val();

    firebase.database().ref(config.baseUrl + "config/parachute_height").set({
      value:openH
    });
    firebase.database().ref(config.baseUrl + "config/parachute_program").set({
      value:progH
    });
    console.log("Updating parachute values");

    sendValue(9, parseInt(progH), parseInt(openH));
  });


  // POWER RATE

  firebase.database().ref(config.baseUrl + "config/tx_rate").on("value", function (snapshot) {
    if(snapshot.val().value === true){
      $("#powersave-mode").removeClass("btn-primary");
      $("#continuous-mode").addClass("btn-primary");
      play("txrate_continuous");
    } else {
      $("#powersave-mode").addClass("btn-primary");
      $("#continuous-mode").removeClass("btn-primary");
      play("txrate_lowenergy");
    }
  });

  $("#powersave-mode").click(function () {
    firebase.database().ref(config.baseUrl + "config/tx_rate").set({
      value:false
    });
  });


  $("#continuous-mode").click(function () {
    firebase.database().ref(config.baseUrl + "config/tx_rate").set({
      value:true
    });
  });

  $("#parachute-open").click(function () {
    sendCommand(0);
    //socket.emit("parachute", true);
  });

  $("#parachute-close").click(function () {
    sendCommand(1);
    //socket.emit("parachute", false)
  });

  $("#btn-parachute-arm").click(function () {
    sendCommand(2);
  })

  $("#btn-parachute-disarm").click(function () {
    sendCommand(3);
  })

  $("#btn-setground").click(function () {
    sendCommand(10);
  });

  $("#btn-blinking-on").click(function () {
    sendCommand(5);
  });

  $("#btn-blinking-off").click(function () {
    sendCommand(6);
  });

  $("#btn-beeping-on").click(function () {
    sendCommand(7);
  });

  $("#btn-beeping-off").click(function () {
    sendCommand(8);
  });

  $("#btn-camara-on").click(function () {
    sendCommand(11);
  });

  $("#btn-camara-off").click(function () {
    sendCommand(12);
  });

  $("#btn-accelcalib").click(function () {
    sendCommand(4);
  });
});

$(function () {
  setInterval(function () {
    let currentH = hbmp;
    let difference = currentH - previousH;
    let difference_time = Date.now() - previousH_time;
    vvel = difference / difference_time;
    if(vvel >= 3.0){
      newStatus = "asc";
      if(newStatus != status){
        play("height_asc");
        status = newStatus;
        $("#parachute-direction").html("ASCENDING");
        $("#parachute-direction").attr("class", "label-ascenso");
      }
    } else if( vvel <= -3.0){
      newStatus = "desc";
      if(newStatus != status){
        play("height_desc");
        status = newStatus;
        $("#parachute-direction").html("DESCENDING");
        $("#parachute-direction").attr("class", "label-descenso");
      }
    } else {
      newStatus = "stable";
      if(newStatus != status){
        play("height_stable");
        status = newStatus;
        $("#parachute-direction").html("STABLE");
        $("#parachute-direction").attr("class", "label-estable");
      }
    }
    $("#label-vvel").html(vvel);
    //updateCansatDirection();
    previousH = currentH;
    previousH_time = Date.now();
  }, 200);
});

function sendCommand(command, param1 = 0, param2 = 0) {
  const command_types = 13;
  line = [];
  line[0] = Math.round(Math.random()* 1000000);
  line[1] = Math.round(Math.random()*1000000) * command_types + command;
  line[2] = param1;
  line[3] = param2;
  line[4] = 0.0;
  line[5] = 0.0;
  line[6] = 0.0;
  line[7] = 0.0;

  cmd = {};
  let lineStr =  "SA" + line.join(",")  + "\n";
  cmd[Date.now() + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5)] = lineStr + lineStr;
  firebase.database().ref("/sats/a_sat/config/commands").set(cmd);
}
